import Cookies from "js-cookie";

initHeader();
function initHeader() {
  // Set header height to global css var
  const header = document.querySelector("#header");

  // Resizer observer
  headerHeight();
  function headerHeight() {
    const root = document.documentElement;
    const nav = header.querySelector(".top-section");
    const footer = document.querySelector("footer.footer");

    if (!nav) return;

    const setHeaderHeight = () => {
      root.style.setProperty("--header", nav.offsetHeight + "px");
      root.style.setProperty("--footer", footer.offsetHeight + "px");
    };

    const resizer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setHeaderHeight();
      }
    });
    resizer.observe(nav);
  }

  // Set up subnavs
  initSubnavs();
  function initSubnavs() {
    const btns = header.querySelectorAll("[subnav-btn]");
    const subnavsOuter = header.querySelector(".subnavs");
    const subnavs = header.querySelectorAll(".subnav");
    const subnavLinks = header.querySelector(".subnav-links");

    if (!subnavs.length) return;

    // Set accordion height with resizeObserver
    const resizer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const subnavScrollHeight = subnavLinks.scrollHeight + "px";
        subnavs[0].style.setProperty("--subnav-height", subnavScrollHeight);
      }
    });

    resizer.observe(subnavs[0]);

    // Set up display interaction
    for (const btn of btns) {
      btn.addEventListener("pointerenter", () => {
        // Set active to btn
        btn.classList.add("active");

        const panel = header.querySelector(
          `.subnav[data-subnav-id="${btn.dataset.subnavId}"]`
        );

        if (!panel) return;

        // Add active state to header
        header.classList.add("hovering");

        // Hide all subnavs
        // subnavs.forEach((s) => (s.style.maxHeight = null));
        subnavs.forEach((s) => (s.style.display = "none"));
        // Show our subnav

        panel.style.display = "grid";
        panel.style.maxHeight = "var(--subnav-height)";
      });
    }

    // Remove hovering state on pointerLeave
    header.addEventListener("pointerleave", () => {
      header.classList.remove("hovering");
      btns.forEach((b) => b.classList.remove("active"));

      subnavs.forEach((s) => {
        s.style.maxHeight = "0px";
      });
    });
  }

  initAnnouncement();
  function initAnnouncement() {
    const announcement = document.querySelector(".announcement");

    // Guard
    if (!announcement) return;

    // Show announcement if closedCookie hasn't been set
    const closedCookie = Cookies.get("kesterblack-announcement-closed");
    if (closedCookie) return;
    announcement.style.display = "flex";

    const close = announcement.querySelector(".btn-close");

    // Observe height
    const resizer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const height = entry.target.scrollHeight;
        entry.target.style.setProperty("--height", height + "px");
      }
    });
    resizer.observe(announcement);

    // Add event
    close.addEventListener("click", () => {
      // Unobserve height changes
      resizer.unobserve(announcement);
      // Add closedCookie
      Cookies.set("kesterblack-announcement-closed", "true", { expires: 1 });

      // Add shrinking class
      announcement.classList.add("shrink");

      announcement.addEventListener(
        "transitionend",
        () => {
          announcement.style.display = "none";
        },
        { once: true }
      );
    });
  }

  // Toggle Mobile Menu
  mobileMenuToggle();
  function mobileMenuToggle() {
    const btn = header.querySelector("[kb-menu-toggle]");
    btn.addEventListener("click", () => {
      header.classList.toggle("mob-menu-open");
    });
  }
}

window.setObservableHeight = (element) => {
  const resizer = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const height = entry.target.scrollHeight;
      entry.target.style.setProperty("--height", height + "px");

      // console.log(height);
    }
  });

  return resizer.observe(element);
};
